export function Event() {
    var self = this;
    var handlers = [];

    self.add = (handler, name) => {
        handler.__name = name;
        handlers.push(handler);
        return {
            remove: () => self.remove(handler),
            unsubscribe: () => self.remove(handler),
        };
    };

    self.remove = (handler: () => void) => {
        var list = [];
        for (var i = 0; i < handlers.length; i++) {
            var h = handlers[i];
            if (h !== handler) {
                list.push(h);
            }
        }
        handlers = list;
    };

    self.dispatch = (...args) => {
        var list = [...handlers];
        for (let i = 0; i < list.length; i++) {
            this.run(list[i], ...args);
        }
    };

    self.run = (handler, ...args) => {
        setTimeout(() => {
            handler(...args);
        }, 0);
    };
}
